// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

	InstantSearchApi.beforeCall = function(eventType, eventInfo) {
		if (Shopify && Globals) {
			Globals.instantSearchQueryParams.currency = Shopify.currency.active;
			Globals.instantSearchQueryParams.currency_rate = Shopify.currency.rate;
			Globals.instantSearchQueryParams.country = Shopify.country;
			Globals.instantSearchQueryParams.return_all_currency_fields = false;
		}
	}
})();
